module.exports = __webpack_public_path__ + "static/img/sh.366acb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/relation/sh.png
// module id = OFZ0
// module chunks = 0